import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import {dataManager} from "../../Broadtask";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {RefreshSharp} from "@mui/icons-material";
import AccountUserCard from "./AccountUserCard";
import {buttonStyle, cardWrapper, sectionPanel} from "../../../AppStyles";

const AccountUsersPane = (props) => {

    const navigate = useNavigate();
    const [users, setUsers] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function onRefresh()
    {
        reload(true);
    }

    function reload(force)
    {
        dataManager.getAccountManager().getUsers(force, (users) => {
            setUsers(users);
        });
    }

    function onAddUser()
    {
        navigate("../account/users/create");
    }

    return (

        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionPanel}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/account_user_registration.png" width={32} height={32}/>
                    <Typography variant="h6">Users</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onRefresh} sx={buttonStyle} startIcon={<RefreshSharp />} />
                    <Button onClick={onAddUser} sx={buttonStyle} startIcon={<AddCircleOutlineIcon />}>Add</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={cardWrapper}>
                {
                    users === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        users.map(nextUser => {
                            return (<AccountUserCard key={"user_" + nextUser.userUID} entry={nextUser} />)
                        })
                }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default AccountUsersPane;
